const datetime = new Intl.DateTimeFormat(navigator.language, {
  year: 'numeric',
  day: 'numeric',
  weekday: 'short',
  month: 'short',
});

export { datetime };
